import React, { useEffect, useMemo, useRef, useState } from 'react';
import { isMobile } from '@icp/utils';
import { Icon } from '@icp/components';
import PropTypes from 'prop-types';
import './AudioElement.css';

function VolumeIcon({ volume }) {
  if (volume === 0) return <Icon name="material:volume-off-rounded" size={20} />;
  if (volume < 0.5) return <Icon name="material:volume-down-rounded" size={20} />;
  return <Icon name="material:volume-up-rounded" size={20} />;
}

VolumeIcon.propTypes = {
  volume: PropTypes.number,
};

function AudioVolumeControl(props) {
  const { volume, onUpdateVolume, appearance, isInDesign } = props;

  const [showVolume, setShowVolume] = useState(false);
  const [prevVolume, setPrevVolume] = useState(volume); // 用于记录静音前的音量
  const wrapperRef = useRef(null);
  const volumeBarStyle = useMemo(
    () => ({
      background: `linear-gradient(to right, #2463eb ${volume * 100}%, ${
        appearance === 'dark' ? '#404040' : '#f0f0f0'
      } ${volume * 100}%)`,
    }),
    [volume, appearance],
  );

  useEffect(() => {
    // 处理点击外部关闭
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowVolume(false);
      }
    };
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMute = () => {
    if (volume > 0) {
      setPrevVolume(volume);
      onUpdateVolume(0);
    } else {
      onUpdateVolume(prevVolume);
    }
  };

  return (
    <div
      className="volume-wrapper"
      ref={wrapperRef}
      onMouseEnter={() => !isMobile() && setShowVolume(true)}
      onMouseLeave={() => !isMobile() && setShowVolume(false)}
    >
      {showVolume && (
        <div className="volume-popover">
          <input
            type="range"
            className="volume-slider-vertical"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={(e) => onUpdateVolume(parseFloat(e.target.value))}
            style={volumeBarStyle}
          />
        </div>
      )}
      <button
        className="volume-icon-btn"
        disabled={isInDesign}
        onClick={() => {
          if (isMobile()) {
            setShowVolume(!showVolume);
          } else {
            toggleMute();
          }
        }}
      >
        <VolumeIcon volume={volume} />
      </button>
    </div>
  );
}

AudioVolumeControl.propTypes = {
  volume: PropTypes.number,
  onUpdateVolume: PropTypes.func,
  appearance: PropTypes.string,
  isInDesign: PropTypes.bool,
};

export default AudioVolumeControl;
